/** localStorage key for consumer SPA theme preference (PRD §7.3). */
export const WI_THEME_KEY = "wi-theme";

export type ThemePreference = "light" | "dark" | "system";
export type ResolvedTheme = "light" | "dark";

export function isThemePreference(value: unknown): value is ThemePreference {
	return value === "light" || value === "dark" || value === "system";
}

export function readStoredTheme(): ThemePreference {
	try {
		const raw = localStorage.getItem(WI_THEME_KEY);
		if (isThemePreference(raw)) return raw;
	} catch {
		/* private mode / blocked storage */
	}
	return "system";
}

export function systemPrefersDark(): boolean {
	return window.matchMedia("(prefers-color-scheme: dark)").matches;
}

export function resolveTheme(preference: ThemePreference): ResolvedTheme {
	if (preference === "system") return systemPrefersDark() ? "dark" : "light";
	return preference;
}

/** Sets data-theme on <html> so [data-theme="dark"|"light"] CSS pairs activate. */
export function applyResolvedTheme(resolved: ResolvedTheme): void {
	document.documentElement.setAttribute("data-theme", resolved);
}

export function persistTheme(preference: ThemePreference): void {
	try {
		localStorage.setItem(WI_THEME_KEY, preference);
	} catch {
		/* ignore */
	}
}

export function applyThemePreference(preference: ThemePreference): ResolvedTheme {
	const resolved = resolveTheme(preference);
	applyResolvedTheme(resolved);
	return resolved;
}
